import { render, staticRenderFns } from "./photo_wall_audit.vue?vue&type=template&id=2cbe4473&scoped=true&"
import script from "./photo_wall_audit.vue?vue&type=script&lang=js&"
export * from "./photo_wall_audit.vue?vue&type=script&lang=js&"
import style0 from "./photo_wall_audit.vue?vue&type=style&index=0&id=2cbe4473&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbe4473",
  null
  
)

export default component.exports